module.exports = __webpack_public_path__ + "static/media/vecteurlogiciel2.d5513d67.png";